/** 浏览器语音播报（陪聊 TTS） */
export function speakText(text, { lang = "zh-CN", rate = 1 } = {}) {
  if (typeof window === "undefined" || !window.speechSynthesis) return false;
  const raw = String(text || "")
    .replace(/[#*`>_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!raw) return false;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(raw.slice(0, 600));
  utter.lang = lang;
  utter.rate = rate;
  window.speechSynthesis.speak(utter);
  return true;
}

export function stopSpeaking() {
  if (typeof window === "undefined") return;
  window.speechSynthesis?.cancel?.();
}

export function ttsSupported() {
  return typeof window !== "undefined" && !!window.speechSynthesis;
}
